import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'signup-modal_submit_email_click-click';

/**
 * CTA click from Signup modal, which should lead to the signup flow
 */
export function trackSignupModalSubmitEmailClickClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
